export default async function getUsers() {
    try {
        const userSession = JSON.parse(sessionStorage.getItem('user'));

        if (!userSession || !userSession.condominio || !userSession.token) {
            throw new Error("Dados insuficientes no sessionStorage.");
        }

        const { condominio, token } = userSession;

        const response = await fetch(`${process.env.REACT_APP_OPENAI_SERVER_EXPRESS}/getUsersByCondominio?condominio=${encodeURIComponent(condominio)}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`Erro ao buscar usuários: ${response.statusText}`);
        }

        const data = await response.json();

        // Garante que `data.users` sempre exista
        if (!data || !data.users) {
            throw new Error("Resposta inválida da API.");
        }

        return data; // Retorna o objeto completo para o front-end
    } catch (error) {
        console.error("Erro ao carregar usuários:", error.message);
        return { users: [] }; // Retorna um objeto padrão em caso de erro
    }
}
